if (!customElements.get('floating-social-buttons')) {
  class FloatingSocialButtons extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.floating-social-buttons__trigger');
      this.list = this.querySelector('.floating-social-buttons__list');
      this.links = this.list ? Array.from(this.list.querySelectorAll('.floating-social-buttons__link')) : [];

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
    }

    connectedCallback() {
      if (!this.trigger || !this.list || this.links.length === 0) return;

      this.setLinksFocusable(false);
      this.trigger.addEventListener('click', this.onTriggerClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    onTriggerClick(event) {
      event.stopPropagation();
      this.isOpen() ? this.close() : this.open();
    }

    open() {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setLinksFocusable(true);
      this.links[0].focus();
    }

    close(options) {
      const focusTrigger = (options && options.focusTrigger) || false;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.setLinksFocusable(false);
      if (focusTrigger) this.trigger.focus();
    }

    setLinksFocusable(focusable) {
      this.links.forEach((link) => {
        if (focusable) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      });
    }

    onKeydown(event) {
      if (!this.isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close({ focusTrigger: true });
        return;
      }

      const currentIndex = this.links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.links[(currentIndex + 1) % this.links.length].focus();
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.links[(currentIndex - 1 + this.links.length) % this.links.length].focus();
      }
    }

    onDocumentClick(event) {
      if (this.isOpen() && !this.contains(event.target)) this.close();
    }
  }

  customElements.define('floating-social-buttons', FloatingSocialButtons);
}
